import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { FuncionService } from '../../servicios/funcion.service';
import { User } from '../../utilidades/utilidades';
import { environment } from '../../../environments/environment.prod';

@Component({
	selector: 'app-acceso',
	templateUrl: './acceso.component.html',
	styleUrls: ['./acceso.component.css']
})
export class AccesoComponent implements OnInit {

	password:string = "";
	newUsuario:User = {
		session:false,
	    username:"",
	    security:{},
	    nombre:"",
	    saldo:"",
	    puntos:"",
	    suscrito:false,
	    divisa:"",
	    totalProductos:0
	}

	constructor(
		private newTitle: Title,
		private newFuncionService:FuncionService,
		private newRouter:Router
		){
	}

	ngOnInit() {
		this.newTitle.setTitle("Acceso");
	}

	fnVerificarUsuario(){
		if( this.newUsuario.username === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.vacio );
		}else if( !environment.validacion.correo.test( this.newUsuario.username ) ){
			this.newFuncionService.setNewAlerta( environment.alerta.acceso.username.formato );
		}else if( this.password === "" ){
			this.newFuncionService.setNewAlerta( environment.alerta.acceso.password );
		}else{
			this.newFuncionService.setNewMensaje("Verificando datos de acceso...");
			this.newFuncionService.fnIniciarSesion( { username:this.newUsuario.username, password:this.password} )
			.subscribe(( response:any ) => {
				this.newUsuario.security = response;
				this.newFuncionService.fnVerifyUser( this.newUsuario );
				
				this.newFuncionService.fnVincularVentaCliente({ venta:{ uuid:this.newFuncionService.currentUuidValue } })
				.subscribe( (response:any) =>{
					if( response.success ){
						this.newFuncionService.fnVerifyUser( this.newUsuario );
					}
				});
				this.newFuncionService.setNewMensaje(null);
				this.newRouter.navigate([""]);
			}, ( error:any ) => {
				this.newFuncionService.setNewAlerta( this.newFuncionService.fnGetNotificationError( error.status ) );
			});
		}
	}

}
